module.exports = __webpack_public_path__ + "static/media/G1-33-Aurora Roussou-cod68-B.0324756c.png";